import PathwayCard from 'components/Cards/PathwayCard';
import { timeToDuration } from 'utils/date';

function PathwayPreview({ formValues: rawFormValues }: PreviewComponentProps) {
  const formValues = rawFormValues as Pathway;
  const attractions = formValues?.pathwayPointsAttributes?.length;
  const duration = timeToDuration(formValues?.duration as string);

  return <PathwayCard name={formValues?.name} attractions={attractions} duration={duration} />;
}

export default PathwayPreview;
